import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { AlertsService } from '../../services/alerts.service';
import cloneDeep from 'lodash/cloneDeep';
import dayjs from 'dayjs';

/**
 * Component for managing a user's international options.
 */
@Component({
	selector: 'user-international-opts',
	templateUrl: './international-opts.component.html',
	styleUrl: './international-opts.component.css'
})
export class InternationalOptsComponent implements OnInit {

	LOCALIZATION: any;

	searchPrefs: any[] = [];
	internationalPrefs = [
		'SET_LANGUAGE_PROPERTY',
		'CL_EXPANSION_LANGUAGE_PROPERTY',
		'USER_INTERFACE_DATE_TYPE',
		'USER_INTERFACE_LANGUAGE'
	];

	include_date_timestamp: boolean = false;
	date_sample: string = '';
	default_date_formats = [
		{ name: "MM/DD/YYYY", value: "MM/DD/YYYY" },
		{ name: "MM-DD-YYYY", value: "MM-DD-YYYY" },
		{ name: "DD/MM/YYYY", value: "DD/MM/YYYY" },
		{ name: "DD-MM-YYYY", value: "DD-MM-YYYY" },
		{ name: "DD-MMM-YYYY", value: "DD-MMM-YYYY" }
	];
	date_format: string = '';
	CL_EXPANSION_LANGUAGE_PROPERTY: any[] = [];

	constructor(
		private alertsService: AlertsService,
		private userService: UserService
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.loadSearchOpts();
	}

	private loadSearchOpts(): void {
		this.date_format = this.default_date_formats[0].value;
		
		let prefs = cloneDeep(this.userService.user.properties.awpropertyObjectList);
		this.searchPrefs = prefs.sort((a: any, b: any) => a.displayName.localeCompare(b.displayName));

		for (let i = 0; i < this.searchPrefs.length; i++) {
			if (this.searchPrefs[i].name == 'CL_EXPANSION_LANGUAGE_PROPERTY') {
				let currentValues = [];
				if (this.searchPrefs[i].value && this.searchPrefs[i].value.length > 0) {
					currentValues = this.searchPrefs[i].value.split(" ");
				}
				for (let j = 0; j < this.searchPrefs[i].optionElementList.length; j++) {
					let selected = false;
					if (currentValues.includes(this.searchPrefs[i].optionElementList[j].value)) {
						selected = true;
					}
					this.CL_EXPANSION_LANGUAGE_PROPERTY.push({
						'name': this.searchPrefs[i].optionElementList[j].name,
						'value': this.searchPrefs[i].optionElementList[j].value,
						'selected': selected
					});
				}
			} else if (this.searchPrefs[i].name == 'USER_INTERFACE_DATE_TYPE') {
				this.date_format = this.searchPrefs[i].value;
				let timestampToken = "hh:mm:ss A";
				if (this.date_format && this.date_format.indexOf(timestampToken) > 0) {
					this.include_date_timestamp = true;
					this.date_format = this.date_format.replace(timestampToken, "").trim();
				}
				this.updateDateSample();
			}
		}
	}

	updateDateSample(): void {
		try {
			let token = this.date_format + (this.include_date_timestamp ? " hh:mm:ss A" : "");
			this.date_sample = dayjs(new Date()).format(token);
		} catch (e) {
			console.error("Failed to parse date.", e);
		}
	}

	updatePreferences(): void {
		let prefs = {
			awpropertyObjectList: this.userService.user.properties.awpropertyObjectList,
			awsortObjectList: this.userService.user.properties.awsortObjectList,
			awfieldObjectList: this.userService.user.properties.awfieldObjectList,
			awfieldCollectionObjectList: this.userService.user.properties.awfieldCollectionObjectList,
			awlibraryObjectList: this.userService.user.properties.awlibraryObjectList
		};

		let expansionLanguages = [];
		for (let i = 0; i < this.CL_EXPANSION_LANGUAGE_PROPERTY.length; i++) {
			if (this.CL_EXPANSION_LANGUAGE_PROPERTY[i].selected) {
				expansionLanguages.push(this.CL_EXPANSION_LANGUAGE_PROPERTY[i].value);
			}
		}
		
		for (let i = 0; i < this.internationalPrefs.length; i++) {
			let property = this.internationalPrefs[i];
			let value = '';
			for (let j = 0; j < this.searchPrefs.length; j++) {
				if (this.searchPrefs[j].name == property) {
					for (let k = 0; k < prefs.awpropertyObjectList.length; k++) {
						if (prefs.awpropertyObjectList[k].name == property) {
							if (property == 'CL_EXPANSION_LANGUAGE_PROPERTY') {
								prefs.awpropertyObjectList[k].value = expansionLanguages.join(" ");
							} else if (property == "USER_INTERFACE_DATE_TYPE") {
								prefs.awpropertyObjectList[k].value = this.date_format + (this.include_date_timestamp ? " hh:mm:ss A" : "");
							} else {
								prefs.awpropertyObjectList[k].value = this.searchPrefs[j].value;
							}
							break;
						}
					}
					break;
				}
			}
		}

		let cleanedPrefs = this.userService.cleanData(prefs);

		let payload = {
			prefs: JSON.stringify(cleanedPrefs)
		};

		this.userService.updateUser(payload).then(
			(response: any) => {
				this.alertsService.success({
					message: this.LOCALIZATION.userProfileUpdateSuccess,
					delay: 5000
				});
			},
			(err: any) => {
				console.error("Failed to update user details.", err);
				this.alertsService.error({
					message: this.LOCALIZATION.userProfileUpdateError,
					delay: 5000
				});
			}
		);
	}
}